// extracted by mini-css-extract-plugin
export default {"noBackground":"a9-z","qnaContainer":"b9-z","qna":"c9-z","question":"d9-z","modal":"e9-z"};